import colors from "@/styles/colors";

export default function TrashIcon(props: React.SVGProps<SVGSVGElement>) {
    const { color = colors.negative } = props;
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 7L10.5 5H13.5L14 7M18 7H7L8 19H16L17 7H6H18ZM12 10V16V10ZM14.5 10L14 16L14.5 10ZM9.5 10L10 16L9.5 10Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}